<!--
 * @Description: 总览
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-06 14:21:59
 -->
<template>
  <div class="productMonitorOverview">
    <div class="line1">
      <div class="line1-left">
        <Line1Left />
      </div>
      <div class="line1-right">
        <Line1Right />
      </div>
    </div>
    <div class="line2">
      <Line2 />
    </div>
    <div class="line3">
      <div class="line3-left">
        <Line3Left />
      </div>
      <div class="line3-right">
        <Line3Right />
      </div>
    </div>
    <div class="line4">
      <Line4 />
    </div>
  </div>
</template>

<script>
import Line1Left from './components/line1Left'
import Line1Right from './components/line1Right'
import Line2 from './components/line2'
import Line3Left from './components/line3Left'
import Line3Right from './components/line3Right'
import Line4 from './components/line4'
export default {
  name: 'productMonitorOverview',
  components: {
    Line1Left,
    Line1Right,
    Line2,
    Line3Left,
    Line3Right,
    Line4,
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .productMonitorOverview {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    .line1 {
      width: 100%;
      height: 320px;
      display: inline-flex;
      justify-content: space-between;
      >div {
        display: inline-block;
      }
      .line1-left {
        width: 50%;
        height: 100%;
      }
      .line1-right {
        width: 50%;
        height: 100%;
      }
    }
    .line2 {
      width: 100%;
      height: 685px;
      position: relative;
    }
    .line3 {
      width: 100%;
      height: 320px;
      display: inline-flex;
      justify-content: space-between;
      .line3-left {
        width: 50%;
        height: 100%;
      }
      .line3-right {
        width: 50%;
        height: 100%;
      }
    }
    .line4 {
      width: 100%;
      height: 300px;
    }
  }
</style>
